module.exports = __webpack_public_path__ + "static/media/Papandopulijana mladih umjetnika 2.7d59640b.jpg";